import React, { memo, useState, ImgHTMLAttributes } from 'react';
import { useStyles } from './styles';
import { ReactComponent as FallbackIcon } from 'assets/icons/FallbackImage.svg';

export interface IImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  fallbackClassName?: string;
  onError?: () => void;
}

const Image = ({ src, alt, className = '', fallbackClassName = '', onError, ...restProps }: IImageProps) => {
  const classes = useStyles();
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
    onError?.();
  };

  if (hasError) {
    return (
      <div className={`${classes.fallbackContainer} ${fallbackClassName || className}`} title={alt}>
        <FallbackIcon />
      </div>
    );
  }

  return <img src={src} alt={alt} className={className} onError={handleError} {...restProps} />;
};

export default memo(Image);
